import React from "react";
import { motion } from "framer-motion";

const chapters = [
  {
    no: "01",
    title: "Kurasi, bukan sekadar jualan.",
    text: "Setiap produk di Winselindo dipilih dengan teliti. Kami hanya menghadirkan gadget original bergaransi resmi dari brand kelas dunia — Apple, Samsung, GoPro, Microsoft, JBL, Bose, dan Meta.",
  },
  {
    no: "02",
    title: "Layanan personal, bukan transaksi dingin.",
    text: "Konsultasi produk gratis via WhatsApp sebelum kamu membeli. Tim kami membantu memilih gadget yang paling sesuai dengan kebutuhan dan bujetmu.",
  },
  {
    no: "03",
    title: "Kepercayaan yang kami rawat.",
    text: "Ribuan pelanggan sejak berdiri. Unit tersegel, harga transparan, dan pengiriman aman ke seluruh Indonesia. Reputasi adalah aset terbesar kami.",
  },
];

const Manifesto = () => {
  return (
    <section id="manifesto" className="relative bg-[#0a0a0a] py-24 lg:py-36 border-y border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="mb-20 max-w-3xl">
          <span className="font-body text-xs uppercase tracking-[0.3em] text-gradient-wl font-semibold">Company Profile</span>
          <h2 className="font-display font-black text-white text-4xl sm:text-5xl lg:text-7xl tracking-tighter mt-4 leading-[0.9]">
            Kami adalah Winselindo.
          </h2>
          <p className="font-body text-white/50 text-lg mt-6">
            Toko gadget terpercaya yang menghadirkan teknologi premium dengan pengalaman belanja yang personal dan profesional.
          </p>
        </div>

        <div className="space-y-px">
          {chapters.map((c, i) => (
            <motion.div
              key={c.no}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: i * 0.05 }}
              className="grid md:grid-cols-12 gap-6 md:gap-10 py-10 border-t border-white/10 group"
            >
              <div className="md:col-span-2">
                <span className="font-display font-black text-5xl md:text-6xl text-white/15 group-hover:text-accent-wl transition-colors duration-500">
                  {c.no}
                </span>
              </div>
              <h3 className="md:col-span-5 font-display font-bold text-2xl md:text-3xl text-white tracking-tight leading-tight">
                {c.title}
              </h3>
              <p className="md:col-span-5 font-body text-white/50 leading-relaxed self-center">
                {c.text}
              </p>
            </motion.div>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-20 pt-10 border-t border-white/10">
          {[
            { n: "7+", l: "Brand Premium" },
            { n: "10K+", l: "Pelanggan Puas" },
            { n: "100%", l: "Original & Bergaransi" },
            { n: "4.9/5", l: "Rating Pelanggan" },
          ].map((s) => (
            <div key={s.l}>
              <div className="font-display font-black text-4xl md:text-5xl text-white">{s.n}</div>
              <div className="font-body text-sm text-white/40 mt-2">{s.l}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
